import { render, staticRenderFns } from "./CameraImage.vue?vue&type=template&id=4c56ec41&"
import script from "./CameraImage.vue?vue&type=script&lang=js&"
export * from "./CameraImage.vue?vue&type=script&lang=js&"
import style0 from "./CameraImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports